module.exports = "<div ng-repeat=\"item in $ctrl.items\" class=\"caseDetails\">\n    <sub>\n        {{item.label}}\n    </sub>\n    <div class=\"margin-t-5\">\n        <span ng-if=\"$ctrl.isString(item.value)\">{{item.value}}</span>\n        <support-feed-attachment ng-if=\"item.name == 'attachments'\" file-name=\"attachment.value\" link=\"attachment.href\" show-icon=\"false\" ng-repeat=\"attachment in item.value track by $index\"></support-feed-attachment>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/support/components/support-view-case-dynamic/supportViewCaseDynamic.component.html
// module id = 756
// module chunks = 0